<template>
  <b-card>
    <b-row class="justify-content-between">
      <b-col class="pr-md-32 pr-md-120">
        <h4>Actionable badges</h4>

        <p class="hp-p1-body">
          Quickly provide actionable badges with hover and focus states by
          specifying either the <code>href</code> prop (links) or
          <code>to</code> prop (router-links):
        </p>
      </b-col>

      <b-col class="hp-flex-none w-auto">
        <b-button
          @click="codeClick()"
          variant="text"
          class="btn-icon-only show-code-btn"
        >
          <i
            class="ri-code-s-slash-line hp-text-color-black-80 hp-text-color-dark-30 lh-1"
            style="font-size: 16px"
          ></i>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <div class="col-12 mt-16">
        <b-badge class="mb-8 mr-8" href="#" variant="primary">Primary</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="secondary">Secondary</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="success">Success</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="danger">Danger</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="warning">Warning</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="info">Info</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="light">Light</b-badge>
        <b-badge class="mb-8 mr-8" href="#" variant="dark">Dark</b-badge>
      </div>

      <div
        v-if="codeActive"
        class="col-12 mt-24 hljs-container"
        :class="{ active: codeActiveClass }"
      >
        <pre v-highlightjs>
          <code class="hljs html">
            {{ codeText }}
          </code>
        </pre>
      </div>
    </b-row>
  </b-card>
</template>

<script>
import { BRow, BCol, BCard, BButton, BBadge } from "bootstrap-vue";

import code from "./code";

export default {
  data() {
    return {
      codeText: code.actionable,
      codeActive: false,
      codeActiveClass: false,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BBadge,
  },
  methods: {
    codeClick() {
      this.codeActive = !this.codeActive;

      setTimeout(() => {
        this.codeActiveClass = !this.codeActiveClass;
      }, 100);
    },
  },
};
</script>
